<template>
    <label :for="for_element"
        :class="label_class ? label_class : 'inline-block leading-snug font-semibold text-gray-warm-800 text-label pb-1 pr-6'"
    >
        <slot />
    </label>
</template>

<script>
export default {
    props: {
        for_element: {},
        label_class: { default: '' },
    },
}
</script>
